import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Input, inject, Output, EventEmitter, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription } from 'rxjs';

import { PaginatedAlbumTemplateRecursiveList } from '@offconon/core-api';
import { BlurhashImageDirective } from '@offconon/shared/ui/image-blurhash';

import { deleteMediaItemFromAlbum } from '../../../store/media-gallery.actions';
import { FilePropertiesFormComponent } from '../file-properties-form/file-properties-form.component';
import { FolderTreeComponent } from '../folder-tree/folder-tree.component';

@Component({
  selector: 'offconon-media-folder-content-card',
  imports: [
    CommonModule,
    TranslateModule,
    PaginatorModule,
    DragDropModule,
    MatIcon,
    TooltipModule,
    ButtonModule,
    MenuModule,
    ConfirmDialogModule,
    FolderTreeComponent,
    DialogModule,
    BlurhashImageDirective,
    FilePropertiesFormComponent,
    PopoverModule,
  ],
  templateUrl: './media-folder-content-card.component.html',
  styles: ``,
})
export class MediaFolderContentCardComponent implements OnInit {
  @Input() multiple = false;
  @Input() saveWithCrop = false;
  @Input() newFiles = {};
  @Input() folderList: PaginatedAlbumTemplateRecursiveList | undefined;
  @Input() media: any;
  @Input() view: string = 'icon';
  @Input() user_id: number = 0;
  @Input() selectedChildren: any[] = [];
  @Input() selectedChildrenParents: any[] = [];
  @Input() business_id: any = null;
  @Input() album_id: number = 0;
  @Input() showType: 'all' | 'image' | 'video' | 'audio' | 'document' | 'zip' | 'other' = 'all';
  @Output() selectedItemEmit = new EventEmitter<any>();
  @Output() selectedFolderIdEmit = new EventEmitter<any>();
  @Output() selectedFolderEmit = new EventEmitter<any>();
  @Output() EditImageEmit = new EventEmitter<any>();
  @Output() ResetSelectedMediaEmmit = new EventEmitter<any>();

  private messageService = inject(MessageService);
  private store = inject(Store);
  private translateService = inject(TranslateService);
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);
  items: MenuItem[];
  pageSize = 10;
  page: number = 1;
  playVideo = false;
  loading = false;
  selectFolder = false;
  copyAction = false;
  editProperty = false;
  iconName = 'file';
  private paginatedSubscription: Subscription;
  public datas: any;
  public results: any;
  public selectedIds: number[] = [];
  public selectedItem: any[] = [];

  ngOnInit(): void {
    this.datas = [];
    this.results = [];
    this.renderMenu(this.media);
    if (this.media.media_file_type === 'document') {
      switch (true) {
        case this.media?.extension?.includes('doc'):
          this.iconName = 'file-word';
          break;
        case this.media?.extension?.includes('xls'):
          this.iconName = 'file-excel';
          break;
        case this.media?.extension?.includes('pdf'):
          this.iconName = 'file-pdf';
          break;
        default:
          this.iconName = 'file';
          break;
      }
    }
  }

  closeDialog() {
    this.selectFolder = false;
  }
  editImage(url: any) {
    this.EditImageEmit.emit(url);
  }
  savedProperties(event: any) {
    this.media.file_name = event.file_name;
    this.media.comment = event.comment;
    this.media.description = event.description;
    this.closePropertiesDialog();
  }
  deleteMedia() {
    if (this.media) {
      let media_ids: any[] = [];
      media_ids.push(this.media.id);
      this.confirmationService.confirm({
        message: this.translate.instant('Are you sure you want to delete this?'),
        header: this.translate.instant('Attention'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.store.dispatch(deleteMediaItemFromAlbum({ id: media_ids }));
          this.messageService.add({
            severity: 'info',
            summary: this.translate.instant('Successful'),
            detail: this.translate.instant('Your request has been successfully completed.'),
          });
        },
        key: 'deleteMediaDialogCard-' + this.media.id,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('Error'),
        detail: this.translate.instant('No selected item found!'),
      });
    }
  }
  showFolders() {
    this.selectFolder = true;
  }
  editProperties(_data: any) {
    this.editProperty = true;
  }
  closePropertiesDialog() {
    this.editProperty = false;
  }
  openNewTab() {
    window.open(this.media.media_file_url, '_blank');
  }

  downloadFile() {
    const link = document.createElement('a');
    link.href = this.media.media_file_url;
    link.download = this.media.file_name + this.media.extension;
    link.target = '_blank';
    link.click();
  }
  /*openDownload() {
    const link = document.createElement('a');
    link.href = this.media.media_file_url;
    link.target = '_self';
    // Ha nincs fájlnév, próbáljuk kinyerni az URL-ből
    const fileName = this.media.file_name || this.media.media_file_url.split('/').pop();
    link.download = fileName;

    // A letöltési fejléc segíthet abban, hogy letöltés legyen
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }*/
  /*downloadFile() {
    fetch(this.media.media_file_url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = this.media.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => console.error('Download failed', err));
  }*/

  renderMenu(data: any) {
    this.items = [
      {
        label: this.translateService.instant('Manage'),
        visible: data,
        items: [
          {
            label: this.translateService.instant('Edit image'),
            icon: 'edit',
            visible: data.media_file_type === 'image' && !this.saveWithCrop,
            command: () => {
              this.editImage(data);
            },
          },
          {
            label: this.translateService.instant('File properties'),
            icon: 'edit',
            visible: data,
            command: () => {
              this.editProperties(data);
            },
          },
          {
            label: this.translateService.instant('Save'),
            icon: 'save',
            visible: data.media_file_type === 'image' && this.saveWithCrop,
            command: () => {
              this.editImage(data);
            },
          },
          {
            label: this.translateService.instant('Play video'),
            icon: 'play_arrow',
            visible: data.media_file_type === 'video',
            command: () => {
              this.playVideo = true;
            },
          },
          {
            label: this.translateService.instant('Open in new tab'),
            icon: 'open_in_new',
            visible: data.media_file_type === 'video' || data.media_file_type === 'image',
            command: () => {
              this.openNewTab();
            },
          },
          {
            label: this.translateService.instant('Open/Download'),
            icon: 'open_in_new',
            visible:
              data.media_file_type === 'document' ||
              data.media_file_type === 'zip' ||
              data.media_file_type === 'other',
            command: () => {
              this.openNewTab();
            },
          },
          {
            label: this.translateService.instant('Download'),
            icon: 'download',
            visible: data,
            command: () => {
              this.downloadFile();
            },
          },
          {
            label: this.translateService.instant('Move'),
            icon: 'send',
            visible: data,
            command: () => {
              this.copyAction = false;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Copy'),
            icon: 'file_copy',
            visible: data,
            command: () => {
              this.copyAction = true;
              this.showFolders();
            },
          },
          {
            label: this.translateService.instant('Delete'),
            icon: 'delete',
            icon_color: 'text-red-500',
            visible: data,
            command: () => {
              this.deleteMedia();
            },
          },
        ],
      },
    ];
  }
}
